import { render, staticRenderFns } from "./ManageActivityScore.vue?vue&type=template&id=5142bcb5&"
import script from "./ManageActivityScore.vue?vue&type=script&lang=js&"
export * from "./ManageActivityScore.vue?vue&type=script&lang=js&"
import style0 from "./ManageActivityScore.vue?vue&type=style&index=0&scop=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports